import { AsyncResp, PaginatedRespData } from '#/api/fetch-api';

/**
 * Utility function to fetch all pages of data from a paginated Paradex API.
 */
export default async function fetchAllPages<ReqParams, Entry>(
  fetchFn: (params: ReqParams) => AsyncResp<PaginatedRespData<Entry>>,
  params: ReqParams,
): Promise<Entry[]> {
  let allResults: Entry[] = [];
  let cursor: string | undefined;

  while (true) {
    const response = await fetchFn({
      ...params,
      cursor,
    });

    if (!response.ok) {
      throw new Error(response.message);
    }

    allResults = [...allResults, ...response.data.results];

    if (response.data.next == null || response.data.next === '') {
      break;
    }

    cursor = response.data.next;
  }

  return allResults;
}
